import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// import UserChip from './UserChip';
import TextChip from './TextChip';

class EntitiyChip extends PureComponent {
    state = {};

    render() {
        const {
            name = '',
            className = '',
            onClick = () => null,
            isDismissible = true,
            onClickDismissible = () => null,
            entity = '',
        } = this.props;

        const commonProps = {
            className,
            onClick,
            isDismissible,
            onClickDismissible,
        };

        switch (entity) {
            /* case 'usuarios':
      case 'users':
        return <UserChip idUser={id} username={name} {...commonProps} />; */
            default:
                return <TextChip text={name} {...commonProps} />;
        }
    }
}

EntitiyChip.propTypes = {
    entity: PropTypes.string,
    id: PropTypes.number,
    name: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    isDismissible: PropTypes.bool,
    onClickDismissible: PropTypes.func,
};

export default EntitiyChip;
